import React, { useState, useEffect, useCallback } from 'react'
import { Template } from '../../Components/Template/template'
import { Link, useNavigate } from 'react-router-dom'
import {
    AlertType, Grupo, GrupoTrib, Marca, ProdAttributes, Produto, SubGrupo, classBorderLabelDark, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo,
    classInput, classInputDark, classLabel, classLabelDark, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classbtVerde
} from '../../Utils/Types'
import { Icone } from '../../Components/Icones/Index'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { IoSearch, IoAddCircleSharp, IoPrint, IoCloseCircleOutline } from 'react-icons/io5'
import { ProdutoService } from './ProdutoService'
import { GridProducts } from '../../Components/GridProducts/GridProducts'
import { FaTrash } from 'react-icons/fa'
import { BsFillBoxSeamFill } from "react-icons/bs"
import { ReportProductsPDF } from './pdf/report-products'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { Tooltip } from 'react-tooltip'
import { AiOutlineClear } from 'react-icons/ai'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'


type produtosFilter = {
    dt_cad_ini: string,
    dt_cad_fim: string,
    tipo_produto: string,
    id_marca: number,
    id_grupo: number,
    id_subgrupo: number,
    tipo_estoque: string,
    status: string,
    id_tributacao: number
}

export const ProductsPage = () => {

    // sem uso
    /*
    //const [btImpDisabled, setbtImpDisabled] = useState<boolean>(false)
    //const [searchBoxResponsivo, setSearchBoxResponsivo] = useState<boolean>(false)
    */


    // ---------- ATRIBUTOS FEEDBACK -----------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO -------------------------------------------
    const [field, setField] = useState('descricao')
    const [filterType, setFilterType] = useState('start')
    const [filter, setFilter] = useState('')

    // ---------- ATRIBUTOS FILTRO AVANÇADO ----------------------------------
    const [datai, setDatai] = useState("")
    const [dataf, setDataf] = useState("")

    const [marcas, setMarcas] = useState<Marca[]>([])
    const [idMarca, setIdMarca] = useState(0)
    const [nomeMarca, setNomeMarca] = useState('')

    const [grupos, setGrupos] = useState<Grupo[]>([])
    const [idGrupo, setIdGrupo] = useState(0)
    const [nomeGrupo, setNomeGrupo] = useState('')

    const [sGrupos, setSGrupos] = useState<SubGrupo[]>([])
    const [idSGrupo, setIdSGrupo] = useState(0)
    const [nomeSubGrupo, setNomeSubGrupo] = useState('')

    const [trib, setTrib] = useState<GrupoTrib[]>([])
    const [idTrib, setIdTrib] = useState(0)
    const [nomeTrib, setNomeTrib] = useState('')

    const [tipoProduto, setTipoProduto] = useState("")
    const [ativo, setAtivo] = useState("")
    const [estoqueFisico, setEstoqueFisico] = useState("")

    const [relatorioFilter, setRelatorioFilter] = useState<produtosFilter>({ dt_cad_ini: '', dt_cad_fim: '', id_grupo: 0, id_marca: 0, id_subgrupo: 0, id_tributacao: 0, status: '', tipo_estoque: '', tipo_produto: '' })

    // ---------- ATRIBUTOS GRID ------------------------------------------------
    const [produtos, setProdutos] = useState<Produto[]>([])
    const [prodAttributes, setProdAttributes] = useState<ProdAttributes>()

    // ---------- ATRIBUTOS SEARCHBOX -------------------------------------------
    const [visibleSearchBoxMarca, setVisibleSearchBoxMarca] = useState<boolean>(false)
    const [visibleSearchBoxGrupo, setVisibleSearchBoxGrupo] = useState<boolean>(false)
    const [visibleSearchBoxSubGrupo, setVisibleSearchBoxSubGrupo] = useState<boolean>(false)
    const [visibleSearchBoxTrib, setVisibleSearchBoxTrib] = useState<boolean>(false)


    //-------------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ---------------------------------------------------------------------//
    const getProdutos = async () => {

        setLoading(true)

        try {

            const produto = await ProdutoService.Filter(field, filter, filterType)
            setProdutos(produto.data)

            const attributes = await ProdutoService.GetAttributes()
            setProdAttributes(attributes.data)

            if (attributes) {
                setGrupos([...attributes.data.grupos])
                setMarcas([...attributes.data.marcas])
                setSGrupos([...attributes.data.sgrupos])
                setTrib([...attributes.data.gTrib])
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar as informações`)

            setProdutos([])

            const timerloding = setTimeout(() => {
                setLoading(false)
                clearTimeout(timerloding)
            }, 0)

            const timer = setTimeout(() => {
                toggleConfig()
                clearTimeout(timer)
            }, 1000)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const toggleConfig = () => {

        let divMenuConfig = document.getElementById('menu_config') as HTMLDivElement
        let variacao = document.getElementById('variacao') as HTMLDivElement
        let subVariacao = document.getElementById('subVariacao') as HTMLDivElement

        if (divMenuConfig) {
            if (divMenuConfig.classList.contains('-right-96')) {
                divMenuConfig.classList.remove('-right-96')
                divMenuConfig.classList.add('right-6')

                if (variacao.innerText === '' || subVariacao.innerText === '') {
                    let count = 0;
                    const interval = setInterval(() => {
                        if (variacao.innerText === '') {
                            variacao.classList.toggle('border-red-600');
                        }
                        if (subVariacao.innerText === '') {
                            subVariacao.classList.toggle('border-red-600');
                        }
                        
                        count++;
                
                        if (count === 6) { // Alterna 3 vezes (liga/desliga)
                            clearInterval(interval);
                        }
                    }, 500);
                }
            }
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroProd") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxMarca && !visibleSearchBoxGrupo && !visibleSearchBoxSubGrupo && !visibleSearchBoxTrib && !loading && menuFiltro.classList.contains("max-h-[1100px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {

            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [filter, filterType, field, datai, dataf, tipoProduto, idMarca, idGrupo, idSGrupo, estoqueFisico, ativo, idTrib, visibleSearchBoxMarca, visibleSearchBoxGrupo, visibleSearchBoxSubGrupo, visibleSearchBoxTrib, loading])

    useEffect(() => {
        getProdutos()
    }, [])

    const inputFocus = () => {
        const inputElement = document.getElementById("pesquisa_produto")
        inputElement?.focus()
    }

    const inputDesfocus = () => {
        const inputElement = document.getElementById("pesquisa_produto")
        inputElement?.blur()
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxGrupo(false)
        setVisibleSearchBoxMarca(false)
        setVisibleSearchBoxSubGrupo(false)
        setVisibleSearchBoxTrib(false)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //-------------------------------------------------------------------- FILTROS -----------------------------------------------------------------------------------//
    const handleChangeField = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const fieldMap: { [key: string]: string } = {
            'descricao': 'descricao',
            'cod_barra': 'cod_barra',
            'referencia': 'referencia',
            'ncm': 'ncm',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setField(selectedField)
            inputFocus()
        }
    }

    const handleFilterTypeChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {

        const filterMap: { [key: string]: string } = {
            'start': 'start',
            'equals': 'equals',
            'contains': 'contains',
        }

        const selectedFilter = filterMap[e.target.value]

        if (selectedFilter) {
            setFilterType(selectedFilter)
            inputFocus()
        }
    }

    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (field === 'ncm') {
            setFilter(e.target.value.replace(/[^0-9]/g, ''))

        } else {
            setFilter(e.target.value)
        }
    }

    useEffect(() => {

        if (field === 'ncm') {
            setFilter(filter.replace(/[^0-9]/g, ''))
        }

    }, [field])

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setProdutos([])
        searchBoxFocus()
        inputDesfocus()

        try {

            const relatorio = {
                dt_cad_ini: datai,
                dt_cad_fim: dataf,
                tipo_produto: tipoProduto,
                id_marca: idMarca,
                id_grupo: idGrupo,
                id_subgrupo: idSGrupo,
                tipo_estoque: estoqueFisico,
                status: ativo,
                id_tributacao: idTrib
            }

            setRelatorioFilter(relatorio)

            if ((relatorio.dt_cad_ini != '' && relatorio.dt_cad_fim == '') || (relatorio.dt_cad_fim != '' && relatorio.dt_cad_ini == '')) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`É necessário colocar as datas de início e fim do período para realizar a pesquisa`)
                    clearTimeout(timer)
                }, 250)

                return
            }

            const produtos = await ProdutoService.Filter(field, filter, filterType, relatorio)
            setProdutos(produtos.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os produtos`)

        } finally {

            const timer = setTimeout(() => {
                inputFocus()
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }

        //setbtImpDisabled(false)
    }

    const filterDados = useCallback(async () => {

        setVisible(false)

        try {

            const relatorio = {
                dt_cad_ini: datai,
                dt_cad_fim: dataf,
                tipo_produto: tipoProduto,
                id_marca: idMarca,
                id_grupo: idGrupo,
                id_subgrupo: idSGrupo,
                tipo_estoque: estoqueFisico,
                status: ativo,
                id_tributacao: idTrib
            }

            const produtos = await ProdutoService.Filter(field, filter, filterType, relatorio)
            setProdutos(produtos.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os produtos`)
            setProdutos([])
        }

    }, [produtos, relatorioFilter, field, filter, filterType, datai, dataf, tipoProduto, idMarca, idGrupo, idSGrupo, estoqueFisico, ativo, idTrib])

    const limparCampoFilter = () => {
        setFilter("")
        inputFocus()
    }

    //-------------------------------------------------------------------- PDF ---------------------------------------------------------------------------------------//
    const handleGerarPDFClick = async (event: any) => {
        try {
            const header = [
                { text: 'Nome Produto', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Qtd. Estoque', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Qtd. Vendido', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
            ]

            const pdf = new ReportProductsPDF(produtos, header, datai, dataf, nomeMarca, nomeGrupo, nomeSubGrupo, nomeTrib, tipoProduto, ativo, estoqueFisico)
            pdf.GerarPDF(produtos)

            event.currentTarget.blur()

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)
        }

    }

    //-------------------------------------------------------------------- FILTROS AVANÇADOS -------------------------------------------------------------------------//
    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroProd") as HTMLDivElement

        //let menuControl = document.getElementById("divMenuControlProd") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsProd") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1100px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            //menuControl.classList.toggle("rounded-md")
            //menuControl.classList.toggle("rounded-t-md")

            if (menuFiltro.classList.contains("max-h-[1100px]")) {

                //menuControl.classList.remove("rounded-md")
                //menuControl.classList.add("rounded-t-md")
                //setSearchBoxResponsivo(true)

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 150)


            } else {
                //menuControl.classList.add("rounded-md")
                //menuControl.classList.remove("rounded-t-md")
                //setSearchBoxResponsivo(false)

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur()
        }
    }

    const handleLimparFiltros = () => {

        /*
        if (datai != '' || dataf != '' || tipoProduto != '' || idMarca != 0 || idGrupo != 0 || idSGrupo != 0 || ativo != '' || estoqueFisico != '' || idTrib != 0) {
            //setbtImpDisabled(true)
        }
        */

        setFilter("")
        setDatai("")
        setDataf("")
        setIdMarca(0)
        setNomeMarca('')
        setIdGrupo(0)
        setNomeGrupo('')
        setIdSGrupo(0)
        setNomeSubGrupo('')
        setIdTrib(0)
        setNomeTrib('')
        setTipoProduto("")
        setAtivo("")
        setEstoqueFisico("")

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        //searchBoxFocus()
        inputFocus()
    }

    /*
    const getFilterProduto = async () => {
        setLoading(true)
        const relatorio = {
            datai: datai,
            dataf: dataf,
            id_marca: idMarca,
            id_grupo: idGrupo,
            id_subgrupo: idSGrupo,
            tipo_produto: tipoProduto,
            ativo: ativo,
            tipo_estoque: estoqueFisico
        }
        const attr = await ProdutoService.FilterRelatorio(relatorio)
        setProdutos(attr)
        setLoading(false)
    }
    */

    const dataiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
        //setbtImpDisabled(true)
    }

    const datafChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
        //setbtImpDisabled(true)
    }

    const tipoProdutoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoProduto(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    const estoqueFisicoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setEstoqueFisico(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    //-------------------------------------------------------------------- MARCAS ------------------------------------------------------------------------------------//
    const handleClearMarcaSelecionada = useCallback(() => {
        const newMarcaList = [...prodAttributes?.marcas || []]
        setMarcas(newMarcaList)
        setIdMarca(0)
        setNomeMarca('')

        setVisibleSearchBoxMarca(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.marcas])

    const handleFilterMarcasClick = useCallback(async (description: string) => {

        if (description === "") {

            const newMarcaList = [...prodAttributes?.marcas || []]
            setMarcas(newMarcaList || [])

        } else {

            const newMarcaList = [...prodAttributes?.marcas || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setMarcas(newMarcaList || [])
        }

    }, [prodAttributes?.marcas])

    const handleMarcasSelectClick = useCallback((v: Marca) => {

        if (v) {
            const newMarcaList = [...prodAttributes?.marcas || []]
            setMarcas(newMarcaList)
            setIdMarca(v.id)
            setNomeMarca(v.description)
        }

        setVisibleSearchBoxMarca(false)
        //setbtImpDisabled(true)
    }, [prodAttributes?.marcas])

    const clickSearchBoxMarca = useCallback(() => {
        setVisibleSearchBoxMarca((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxMarca
                setVisibleSearchBoxGrupo(false)
                setVisibleSearchBoxSubGrupo(false)
                setVisibleSearchBoxTrib(false)
                inputFocusMarca()
            }
            return newState
        })
    }, [])

    const inputFocusMarca = () => {
        let inputSearch = document.getElementById(`inputSearchBox-marca`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //-------------------------------------------------------------------- GRUPOS ------------------------------------------------------------------------------------//
    const handleClearGrupoSelecionada = useCallback(() => {
        const newGrupoList = [...prodAttributes?.grupos || []]
        setGrupos(newGrupoList)
        setIdGrupo(0)
        setNomeGrupo('')

        setVisibleSearchBoxGrupo(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.grupos])

    const handleFilterGruposClick = useCallback(async (description: string) => {

        if (description === "") {

            const newGrupoList = [...prodAttributes?.grupos || []]
            setGrupos(newGrupoList || [])

        } else {

            const newGrupoList = [...prodAttributes?.grupos || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setGrupos(newGrupoList || [])
        }

    }, [prodAttributes?.grupos])

    const handleGruposSelectClick = useCallback((v: Grupo) => {

        if (v) {
            const newGrupoList = [...prodAttributes?.grupos || []]
            setGrupos(newGrupoList)
            setIdGrupo(v.id)
            setNomeGrupo(v.description)
        }

        setVisibleSearchBoxGrupo(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.grupos])

    const clickSearchBoxGrupo = useCallback(() => {
        setVisibleSearchBoxGrupo((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxGrupo
                setVisibleSearchBoxMarca(false)
                setVisibleSearchBoxSubGrupo(false)
                setVisibleSearchBoxTrib(false)
                inputFocusGrupo()
            }
            return newState
        })
    }, [])

    const inputFocusGrupo = () => {
        let inputSearch = document.getElementById(`inputSearchBox-grupo`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //-------------------------------------------------------------------- SUBGRUPOS ---------------------------------------------------------------------------------//
    const handleClearSubGrupoSelecionada = useCallback(() => {
        const newSGrupoList = [...prodAttributes?.sgrupos || []]
        setSGrupos(newSGrupoList)
        setIdSGrupo(0)
        setNomeSubGrupo('')

        setVisibleSearchBoxSubGrupo(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.sgrupos])

    const handleFilterSubGruposClick = useCallback(async (description: string) => {

        if (description === "") {

            const newSGrupoList = [...prodAttributes?.sgrupos || []]
            setSGrupos(newSGrupoList || [])

        } else {

            const newSGrupoList = [...prodAttributes?.sgrupos || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setSGrupos(newSGrupoList || [])
        }

    }, [prodAttributes?.sgrupos])

    const handleSubGruposSelectClick = useCallback((v: SubGrupo) => {

        if (v) {
            const newSGrupoList = [...prodAttributes?.sgrupos || []]
            setSGrupos(newSGrupoList)
            setIdSGrupo(v.id)
            setNomeSubGrupo(v.description)
        }

        setVisibleSearchBoxSubGrupo(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.sgrupos])

    const clickSearchBoxSubGrupo = useCallback(() => {
        setVisibleSearchBoxSubGrupo((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxSubGrupo
                setVisibleSearchBoxGrupo(false)
                setVisibleSearchBoxMarca(false)
                setVisibleSearchBoxTrib(false)
                inputFocusSubGrupo()
            }
            return newState
        })
    }, [])

    const inputFocusSubGrupo = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subGrupo`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //-------------------------------------------------------------------- TRIBUTAÇÃO ---------------------------------------------------------------------------------//
    const handleClearTribSelecionada = useCallback(() => {
        const newTribList = [...prodAttributes?.gTrib || []]
        setTrib(newTribList)
        setIdTrib(0)
        setNomeTrib('')

        setVisibleSearchBoxTrib(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.gTrib])

    const handleFilterTribClick = useCallback(async (description: string) => {

        if (description === "") {

            const newTribList = [...prodAttributes?.gTrib || []]
            setTrib(newTribList || [])

        } else {

            const newTribList = [...prodAttributes?.gTrib || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setTrib(newTribList || [])
        }

    }, [prodAttributes?.gTrib])

    const handleTribSelectClick = useCallback((v: GrupoTrib) => {

        if (v) {
            const newTribList = [...prodAttributes?.gTrib || []]
            setTrib(newTribList)
            setIdTrib(v.id)
            setNomeTrib(v.description)
        }

        setVisibleSearchBoxTrib(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.gTrib])

    const clickSearchBoxTrib = useCallback(() => {
        setVisibleSearchBoxTrib((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxTrib
                setVisibleSearchBoxGrupo(false)
                setVisibleSearchBoxSubGrupo(false)
                setVisibleSearchBoxMarca(false)
                inputFocusTrib()
            }
            return newState
        })
    }, [])

    const inputFocusTrib = () => {
        let inputSearch = document.getElementById(`inputSearchBox-tributacao`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ----------------------------------------------------------- NAVEGAÇÃO ------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaProduto = () => {
        //navigate("/produtos/new")
    }

    return (

        <Template isLoading={loading}>

            <div className={classDivBackground}>

                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div id="div-body" role='button' className={`${classDivBody}`}>

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-8 sm:col-span-10 xl:col-span-5 flex flex-row items-center`}>
                            <BsFillBoxSeamFill className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Produtos</span>
                        </div>

                        <div className={`relative col-span-4 sm:col-span-2 xl:col-span-1`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/produtos/excluidos'} data-tooltip-id={'tooltip-btn-lixeira'} id={'btn-lixeira'} className={`${classbtColunasVermelho} h-9`} >
                                <FaTrash className={`mx-2`} size="25px" />

                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-btn-lixeira'} anchorSelect={'#btn-lixeira'} positionStrategy="fixed" place='left' >
                                    <span>Produtos Excluídos</span>
                                </Tooltip>

                            </Link>

                        </div>

                        <div className={`relative col-span-4 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-4 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(produtos.length > 0)} onClick={handleGerarPDFClick}>
                                <IoPrint size="20px" className='mr-2 hidden md:block' /> Imprimir
                            </button>
                        </div>

                        <div className={`relative col-span-4 xl:col-span-2`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/produtos/new'} className={`${classBtSemDuration} ${classbtVerde} h-9`} >
                                <IoAddCircleSharp className={`mx-2 hidden md:block`} size="20px" /> Cadastro
                            </Link>

                            {/* 
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtVerde} h-9 `} onClick={navegarTelaProduto}>
                                <IoAddCircleSharp size="20px" className='mr-2 hidden md:block ' /> Cadastro
                            </button>
                            */}
                        </div>

                    </div>

                    <div id='divInputsProd' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroProd' className={`relative max-h-[0px] h-[1050px] sm:h-[410px] xl:h-[340px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-7 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select disabled={loading} id='filter_to' className={`${classInput} ${classInputDark} `} value={field} onFocus={searchBoxFocus} onChange={handleChangeField}>
                                    <option value="descricao">DESCRIÇÃO</option>
                                    <option value="cod_barra">CÓD. BARRAS</option>
                                    <option value="referencia">REFERÊNCIA</option>
                                    <option value="ncm">NCM</option>
                                </select>
                                <label htmlFor="filter_to" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}><Icone icon={faFilter} /><span className={`ml-2`}>Filtrar por</span></label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select disabled={loading} id='filter_type' className={`${classInput} ${classInputDark} `} value={filterType} onFocus={searchBoxFocus} onChange={handleFilterTypeChange}>
                                    <option value="start">INICIA COM</option>
                                    <option value="equals">IGUAL A</option>
                                    <option value="contains">CONTÉM</option>
                                </select>
                                <label htmlFor="filter_type" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Critério</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-6 xl:col-span-8 mt-3 sm:mt-0`}>
                                <input id='pesquisa_produto' className={`${classInput} ${classInputDark} pr-10`} maxLength={field === 'ncm' ? 8 : 999} placeholder=' ' autoComplete="off" value={filter} onFocus={searchBoxFocus} onChange={handleChangeFilter} />
                                <label htmlFor="pesquisa_produto" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Digite sua consulta</label>
                                <button onClick={limparCampoFilter} className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none ${filter === '' ? 'invisible' : 'visible'}`}>
                                    <IoCloseCircleOutline size="25px" />
                                </button>
                            </div>

                            <div className={`relative col-span-12`}>
                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Filtros Avançados</span>
                                <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700 w-[100%] mt-2`} />
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <input id='data-inicial' type='date' className={`${classInput} ${classInputDark} dark:[color-scheme:dark] ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onFocus={searchBoxFocus} onChange={dataiChange} />
                                <label htmlFor="data-inicial" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Cadastro Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <input id='data-final' type='date' className={`${classInput} ${classInputDark} dark:[color-scheme:dark] ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onFocus={searchBoxFocus} onChange={datafChange} />
                                <label htmlFor="data-final" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Cadastro Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-3`}>
                                <select id="tipo" className={`${classInput} ${classInputDark}  ${tipoProduto === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={tipoProduto} onFocus={searchBoxFocus} onChange={tipoProdutoChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}>( selecione )</option>
                                    <option value="P" className={`text-slate-900 dark:text-slate-200`}>Produto para revenda</option>
                                    <option value="M" className={`text-slate-900 dark:text-slate-200`}>Matéria prima</option>
                                    <option value="S" className={`text-slate-900 dark:text-slate-200`}>Serviço</option>

                                </select>

                                <label htmlFor="tipo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-1 mt-3`}>
                                <select id="ativo" className={`${classInput} ${classInputDark}  ${ativo === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}>( selecione )</option>
                                    <option value="S" className={`text-slate-900 dark:text-slate-200`}>Sim</option>
                                    <option value="N" className={`text-slate-900 dark:text-slate-200`}>Não</option>
                                </select>

                                <label htmlFor="ativo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <select id="estoque" className={`${classInput} ${classInputDark} ${estoqueFisico === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={estoqueFisico} onFocus={searchBoxFocus} onChange={estoqueFisicoChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}>( selecione )</option>
                                    <option value="0" className={`text-slate-900 dark:text-slate-200`}>Com Estoque</option>
                                    <option value="1" className={`text-slate-900 dark:text-slate-200`}>Sem Estoque</option>
                                    <option value="2" className={`text-slate-900 dark:text-slate-200`}>Estoque Negativo</option>
                                    <option value="3" className={`text-slate-900 dark:text-slate-200`}>Atingiu o Estoque Mínimo</option>
                                </select>

                                <label htmlFor="estoque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Estoque</label>
                            </div>

                            <div id='componenteMarca' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 mt-3`}>
                                <SearchBox
                                    dataList={marcas}
                                    idRegistro={idMarca || undefined}
                                    label='Marca'
                                    componentId='marca'
                                    visibleTAB={visibleSearchBoxMarca}
                                    setDataClick={handleMarcasSelectClick}
                                    clearDataClick={handleClearMarcaSelecionada}
                                    filterDataClick={handleFilterMarcasClick}
                                    clicado={clickSearchBoxMarca}
                                />
                            </div>

                            <div id='componenteGrupo' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 mt-3`}>
                                <SearchBox
                                    dataList={grupos}
                                    idRegistro={idGrupo || undefined}
                                    label='Grupo'
                                    componentId='grupo'
                                    visibleTAB={visibleSearchBoxGrupo}
                                    setDataClick={handleGruposSelectClick}
                                    clearDataClick={handleClearGrupoSelecionada}
                                    filterDataClick={handleFilterGruposClick}
                                    clicado={clickSearchBoxGrupo}
                                />
                            </div>

                            <div id='componenteSubGrupo' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 mt-3`}>
                                <SearchBox
                                    dataList={sGrupos}
                                    idRegistro={idSGrupo || undefined}
                                    label='SubGrupo'
                                    componentId='subGrupo'
                                    visibleTAB={visibleSearchBoxSubGrupo}
                                    setDataClick={handleSubGruposSelectClick}
                                    clearDataClick={handleClearSubGrupoSelecionada}
                                    filterDataClick={handleFilterSubGruposClick}
                                    clicado={clickSearchBoxSubGrupo}
                                />
                            </div>

                            <div id='componenteTributacao' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 mt-3`}>
                                <SearchBox
                                    dataList={trib}
                                    idRegistro={idTrib || undefined}
                                    label='Tributação'
                                    componentId='tributacao'
                                    visibleTAB={visibleSearchBoxTrib}
                                    setDataClick={handleTribSelectClick}
                                    clearDataClick={handleClearTribSelecionada}
                                    filterDataClick={handleFilterTribClick}
                                    clicado={clickSearchBoxTrib}
                                />
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridProducts produto={produtos} handleUpdateProdutosList={filterDados} />
                    </div>

                </div>

            </div>

        </Template>
    )
}